var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 431,
    viewBox: "0 0 1440 431",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 12.9999,
    x2: 12.4687,
    y1: 69,
    y2: 368.645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc594f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0548279,
    stopColor: "#fc594f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848928,
    stopColor: "#5522b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e4a92",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    x2: 52.5761,
    y1: 81,
    y2: 388.686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc594f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0881905,
    stopColor: "#fc594f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891583,
    stopColor: "#5522b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e4a92",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 57.0001,
    x2: 70.7494,
    y1: 120,
    y2: 439.891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc594f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582288,
    stopColor: "#fc594f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891583,
    stopColor: "#5522b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e4a92",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc594f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#fc594f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891583,
    stopColor: "#5522b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e4a92",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 85.226,
    x2: 106.56,
    xlinkHref: "#d",
    y1: 145.921,
    y2: 472.777
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 70.2466,
    x2: 101.29,
    xlinkHref: "#d",
    y1: 166.905,
    y2: 510.902
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 55.7539,
    x2: 97.3251,
    xlinkHref: "#d",
    y1: 188.213,
    y2: 549.008
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7561,
    x2: 94.6547,
    xlinkHref: "#d",
    y1: 209.835,
    y2: 587.057
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 28.2614,
    x2: 93.269,
    xlinkHref: "#d",
    y1: 231.763,
    y2: 625.012
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2777,
    x2: 93.1565,
    xlinkHref: "#d",
    y1: 253.986,
    y2: 662.836
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-77.5455 76.8924c76.3554-2.2822 126.8173-49.6065 280.9905-15.7377 154.174 33.8688 222.376 95.6783 377.719 108.3133s217.763 57.389 346.624 111.45c193.462 81.164 541.312 97.787 541.312 97.787",
    stroke: "url(#a)",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-95.539 101.778c76.8839-4.4117 127.225-56.1524 282.86-24.0556 155.636 32.0966 224.965 96.1976 381.561 105.6356 156.595 9.439 219.925 55.514 350.272 109.785 195.696 81.48 546.226 90.178 546.226 90.178",
    stroke: "url(#b)",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-112.963 127.066c77.3607-6.559 127.442-62.7257 284.524-32.4419 157.082 30.2839 227.639 96.6549 385.423 102.8569 157.783 6.201 222.089 53.579 353.968 108.025 197.998 81.741 551.048 82.425 551.048 82.425",
    stroke: "url(#c)",
    strokeWidth: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m-129.808 152.747c77.7863-8.725 127.46851-69.323 285.981-40.893 158.513 28.429 230.398 97.046 389.304 99.973 158.906 2.926 224.251 51.586 357.708 106.168 200.365 81.947 555.755 74.533 555.755 74.533",
    stroke: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-146.064 178.809c78.1599-10.908 127.3033-75.939 287.229-49.404 159.926 26.535 233.24 97.37 393.201 96.984 159.962-.386 226.412 49.534 361.492 104.213 202.802 82.093 560.352 66.5 560.352 66.5",
    stroke: "url(#f)",
    strokeWidth: 1.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m-161.721 205.241c78.4808-13.106 126.9457-82.569 288.267-57.97 161.321 24.599 236.162 97.623 397.111 93.889 160.95-3.734 228.569 47.42 365.315 102.156 205.308 82.177 564.838 58.328 564.838 58.328",
    stroke: "url(#g)",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m-176.769 232.031c78.7479-15.318 126.3944-89.208 289.092-66.586 162.697 22.622 239.164 97.802 401.033 90.686 161.87-7.116 230.719 45.246 369.175 99.996 207.869 82.199 569.219 50.02 569.219 50.02",
    stroke: "url(#h)",
    strokeWidth: 1.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m-191.2 259.168c78.962-17.543 125.6505-95.851 289.7038-75.247 164.0532 20.605 242.2432 97.905 404.9632 87.373s232.864 43.01 373.072 97.731c210.501 82.155 573.471 41.577 573.471 41.577",
    stroke: "url(#i)",
    strokeWidth: 1.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m-205.004 286.64c79.122-19.78 124.7126-102.495 290.1007-83.949 165.3883 18.546 245.3993 97.928 408.8993 83.949s235 40.714 377 95.36c213.194 82.043 577.604 33 577.604 33",
    stroke: "url(#j)",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.597ccc26771b83bd4b0e83dd162aedce.svg";
export { ForwardRef as ReactComponent };